import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import HomeIcon from '@mui/icons-material/Home';
import { Box, Button, IconButton, LinearProgress, Link } from "@mui/material";
import { DataGrid, GridColDef, GridToolbarFilterButton } from '@mui/x-data-grid';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { config } from "../../Constants";
import useAuth from "../../context/AuthProvider";
import { PartnersModel } from "../../models/PartnersModel";
import { stateOptions } from "../AddEdit/AddEditPartners";
import { text } from 'stream/consumers';
import moment from 'moment';
import { RiExpandUpDownLine } from "react-icons/ri";
import { apiClient } from '../../helper/api';
interface Iprops {
    PartnersCL: PartnersModel[],
    fetchData: () => void
}

export const PartnersList: React.FC<Iprops> = ({ PartnersCL, fetchData }) => {
    const [loading, setloading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;

    const initialLBData: PartnersModel = {
        partnersId: 0,
        customerName: "",
        partnerTypeId: 0,
        streetAddress: "",
        suitOrUnit: "",
        city: "",
        state: 0,
        zipCode: "",
        agencyLicense: "",
        taxId: "",
        numberOfStates: "",
        filingContactName: "",
        filingContactEmail: "",
        filingContactPhone: "",
        accountingContactName: "",
        accountingContactEmail: "",
        accountingContactPhone: "",
        licenseeContactName: "",
        licenseeContactEmail: "",
        licenseeContactPhone: "",
        slaAdminContactName: "",
        slaAdminContactEmail: "",
        slaAdminContactPhone: "",
        escalationContactName: "",
        escalationContactEmail: "",
        escalationContactPhone: "",
        drlpContactName: "",
        drlpContactEmail: "",
        drlpContactPhone: "",

        paymentPartnerType: 0,
        paymentStreetAddress: "",
        paymentSuitOrUnit: "",
        paymentCity: "",

        paymentZipCode: 0,
        paymentNaic: "",
        paymentTaxId: "",
        partnerIntegrationType: 0,
        agencyPolicyManagementSystem: "",
        userName: "",
        password: "",

        modifiedBy: 0,
        paymentType: true,
        paymentState: 0,
        createdBy: 0,

        status: false,
        typeName: ""

    }

    const [partnerStates, setPartnerStates] = useState<stateOptions[]>([]);
    const [Open, setOpen] = React.useState(false);
    const [Formdata, setFormData] = React.useState<PartnersModel>(initialLBData);
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    const handleClose = () => {

        setOpen(false);
    };
    const handleSubmit = () => {
        fetchData();
        setOpen(false);
    };
    const handleClickOpen = () => {
        setPartnerStates([]);
        setFormData(initialLBData);
        setOpen(true);
    };

    const handleEdit = (ILobData: PartnersModel) => {

        apiClient(`/Partners/getPartnerStates?partnersId=${ILobData.partnersId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                if (!responseJson) return
                // Do something with the response
                console.log(responseJson.data, "fetchdata");
                setPartnerStates(responseJson.data);
                // setSelectedOption(States.filter(x => partnerStates.map((item)=>(item.stateId))));
            })
        setFormData(ILobData);

        setOpen(true);
    };

    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/Partners/Delete?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res) return
                            Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            )
                            fetchData();
                            setOpen(false);
                        })

                }
            })
    };

    function EditToolbar() {
        return (
            <div className="row col-lg-12" style={{ marginBottom: "10px" }}>

                <div className="d-flex justify-content-between">
                    <div className="" >
                        <span className="card-title" >Clients</span>
                    </div>
                    {user?.userRoles.split(",").includes("Super Admin")  ?
                        <div className="" style={{ textAlign: "right" }}>
                            <Link href={'/AddEditPartners/' + 0} sx={{ textDecoration: "none " }}>
                                {/* <button type="button" className="btn btn-primary action-btn"> <i className="fa-solid fa-right-long"></i></button> */}
                                <button
                                    className="active-btn-blue"
                                // onClick={() => { handleEdit(params.row) }}

                                >
                                    Add New
                                </button >
                            </Link>

                        </div>
                        : ""}
                </div>
            </div>


        );
    }
    const columns: GridColDef[] = [
        {
            field: 'customerName', type: 'text', headerName: 'Client Name', headerAlign: "center", hideSortIcons: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), flex: 1, align: 'center'
        },
        {
            field: 'typeName', type: 'text', headerName: 'Client Type', headerAlign: "center", flex: 1, hideSortIcons: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: 'center'
        },
        // {
        //     field: 'status', type: 'boolean', headerName: 'Status', headerAlign: 'center', align: 'center', flex: 0.8,
        //     renderCell: (params) =>
        //     (
        //         <div>
        //             {params.row.status ? "Active" : "Inactive"}
        //         </div>
        //     )
        // },

        {
            field: 'status', type: 'text', headerName: 'Status', headerAlign: "center", flex: 0.8, hideSortIcons: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), align: 'center',
            valueGetter: (params) => {
                return (params.row?.status ? "Active" : "InActive")
            }

        },

        {
            field: 'dateCreated', headerName: 'Start Date', headerAlign: "center", flex: 1, align: 'center', hideSortIcons: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), renderCell: (params) =>
            (
                <div>

                    {/* {params.row?.effectiveDate ? moment(params.row?.effectiveDate).format("MM/DD/YYYY") : ""} */}
                    {params.row.dateCreated?.toString().split('T')[0]}
                </div>
            )
        },
        {
            field: 'partnersId', flex: 0.5, headerName: "Action", headerAlign: "center", align: 'center', hideSortIcons: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), renderCell: (params) =>
            (<div>

                <Link href={'/AddEditPartners/' + params.value} sx={{ textDecoration: "none " }}>
                    {/* <button type="button" className="btn btn-primary action-btn"> <i className="fa-solid fa-right-long"></i></button> */}
                    <IconButton
                        color="primary"
                    // onClick={() => { handleEdit(params.row) }}

                    >  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z" stroke="#02A4E3" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </IconButton >
                </Link>
                {user?.userRoles.split(",").includes("Super Admin") ?
                    <IconButton
                        color="error"
                        onClick={() => { handleDelete(params.row.partnersId); }}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#162E3C" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </IconButton>
                    : ""}
            </div>)
        },

    ];

    return (

        <div style={{ height: '65vh', width: '100%' }}>
            {loading && <LinearProgress sx={{ backgroundColor: "#132D3D" }} />}

            <DataGrid
                getRowId={(r) => r.partnersId}
                rows={PartnersCL}
                columns={columns}
                pageSize={50}

                rowsPerPageOptions={[50]}
                components={{
                    Toolbar: EditToolbar

                }}
                sx={{
                    border: "0px",
                    fontSize: "16px",
                    width: "100%",


                }}

            // sx={{
            //     "& .MuiDataGrid-columnHeaderTitle": {
            //         whiteSpace: "normal",
            //         lineHeight: "normal",
            //         padding: "18px 0px"
            //     },
            //     fontFamily: "'Proxima Nova', sans-serif;",
            //     border: "0px",
            //     fontSize: "16px",
            // }}
            />
            {/* < AddEditPartners handleClose={handleClose} Open={Open} CustomerPartnersCL={Formdata} handleSubmit={handleSubmit} initValues={initialLBData} selectedStates ={partnerStates} /> */}
        </div>



    )
}